import React from "react";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import MaContainer from "../../Components/Common/container";
import { LuChevronRight } from "react-icons/lu";

import { Link } from "react-router-dom";

import { useQuery } from "@apollo/client";
import { GET_CATEGORIES_N_SUB } from "../../Utils/Queries";
import ContinentalProductCard from "../../Components/Cards/continental-product-card";
import Loader from "../../Components/Common/Loader";
import EmptyData from "../../Components/Common/EmptyData";

const CategoryListings = () => {
  const { loading, data, error } = useQuery(GET_CATEGORIES_N_SUB);

  const categories = data?.fetchAllCategoriesAndTheirSubCategories || [];

  console.log(categories);

  return (
    <div>
      {loading && <Loader />}
      <Navbar />

      <MaContainer>
        <div className="pt-10">
          <div className="flex items-center gap-x-3">
            <Link to="/">
              <span className="text-[14px] text-[#727272]">Home</span>
            </Link>
            <LuChevronRight className="text-[#71747E] text-[12px]" />

            <span className="text-[14px] text-[#353535]">Categories</span>
          </div>

          <h1 className="mt-4 capitalize text-[28px] font-bold leading-tight text-[#1a1a1a] md:text-[32px]">
            Categories
          </h1>

          <section className="mt-10 pb-10" aria-label="Products">
            {categories.length === 0 && (
              <EmptyData
                title="No categories found"
                label="No categories found"
              />
            )}
            <div className="grid grid-cols-2 items-stretch gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4 lg:gap-6">
              {categories.map((cat) => (
                <div key={cat.category._id} className="min-w-0">
                  <Link
                    to={`/category-view/${cat.category.name}/${cat.category._id}`}
                    className="block h-full cursor-pointer"
                  >
                    <div className="flex h-[170px] items-center gap-x-2 bg-[#F8F8F8] flex-col justify-center p-4 rounded-lg">
                      <img
                        src={cat.category.image}
                        alt={cat.category.name}
                        className="w-20 h-20 rounded-lg"
                      />
                      <div className="mt-4 text-[14px] font-bold text-[#181818] capitalize">
                        {cat.category.name}
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </section>
        </div>
      </MaContainer>

      <Footer />
    </div>
  );
};

export default CategoryListings;
